export const ESPONDILOARTRITES_ELEMENTS_OPTIONS = {
  AXIAL: [
    { key: 'boa_resposta_aine', name: 'Boa resposta a AINE' },
    {
      key: 'doenca_de_crohn_ou_retocolite_ulcerativa',
      name: 'Doença de Crohn ou retocolite ulcerativa',
      disabled: true,
    },
    { key: 'historia_familiar_espondiloartrite', name: 'História familiar de espondiloartrite' },
    { key: 'hla_b27', name: 'HLA-B27' },
    { key: 'proteina_c_reativa_elevada', name: 'Proteina C reativa elevada' },
  ],
  PERIFERICO: [
    { key: 'doenca_inflamatoria_intestinal', name: 'Doença inflamatória intestinal atual', disabled: true },
    { key: 'infeccao_previa', name: 'Infecção prévia ao início dos sintomas' },
    { key: 'hla_b27', name: 'HLA-B27' },
    { key: 'dor_lombar_inflamatoria_no_passado', name: 'Dor lombar inflamatória no passado' },
    { key: 'historia_familiar_espondiloartrite', name: 'História familiar de espondiloartrite' },
    {
      key: 'possui_sacroileite_exame_imagem',
      name: 'Sacroileíte em imagem (Raio-X com sacroileíte grau II bilateral ou grau III unilateral OU Sacroileíte ativa em RNM altamente sugestivo de espondiloartrite)',
    },
  ],
}

export const POSITIVE_IMAGE_EXAM_VALUES = ['GRAU_II_III', 'ATIVA', 'GRAU_II_III_E_ATIVA', true]

export const IMAGE_EXAM_OPTIONS = [
  {
    text: 'Radiografia com sacroileíte grau II bilateral ou grau III unilateral',
    value: 'GRAU_II_III',
  },
  {
    text: 'Sacroileíte ativa em ressonância altamente sugestivo de espondiloartrite',
    value: 'ATIVA',
  },
  {
    text: 'Ambas as opções acima',
    value: 'GRAU_II_III_E_ATIVA',
    label:
      'Radiografia com sacroileíte grau II bilateral ou grau III unilateral e Sacroileíte ativa em ressonância altamente sugestivo de espondiloartrite',
  },
  { text: 'Resultado inconclusivo ou duvidoso', value: 'INCONCLUSIVO' },
  { text: 'Ainda não fez esse exame', value: 'NAO_REALIZADO' },
]
